import merge from 'lodash-es/merge';
import get from 'lodash-es/get';
import getDefaultStyle from '../css/defaultStyle';

export function getDefaultSwitchStyle(control) {
  const instance = control.instance;
  const design = get(control,['options','lookAndFeel','controlsDesign'],'classic');
  if (!getDefaultSwitchStyle[control.designMode]) {
    getDefaultSwitchStyle[control.designMode]={};
  }

  if (!getDefaultSwitchStyle[instance.args.designMode][design]) {
    getDefaultSwitchStyle[instance.args.designMode][design] = {
      normal: merge({}, getDefaultStyle(), {
        position: 'absolute',
        cursor: 'pointer',
        transitionProperty: 'all',
        transitionDuration: '${schemeAnimationDuration}',
        transitionTimingFunction: 'ease',
        transitionDelay: '0s',
        top: '8px',
        left: '8px',
        width: '112px',
        height: '16px',
        margin: '0px',
        display: 'inline-block',
        userSelect: 'none',
      }),
      body: {
        normal: merge({}, getDefaultStyle(), {
          display: 'block',
          position: 'absolute',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
          width: '100%',
          height: '100%',
          margin: '0px',
          whiteSpace: 'nowrap',
          overflow: 'visible',
        }),
        hover: {},
        top: {
          textAlign: 'center',
        },
        right: {},
        bottom: {
          textAlign: 'center',
        },
        left: {
          textAlign: 'right',
        },
      },
      hover: {},
      box: {
        normal: merge({}, getDefaultStyle(), {
          transformOrigin: 'center',
          transitionProperty: 'all',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          boxSizing: 'border-box',
          backgroundColor: '${schemeForeground}',
          borderStyle: 'solid',
          // borderColor: '${schemeShade}',
          borderColor: '#888',
          borderWidth: '1px',
          borderRadius: '9999px',
          // boxShadow: '0px 2px 4px rgba(0,0,0,0.4), 0 -12px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset',
          boxShadow: design=='classic'?
            '0px 2px 4px rgba(0,0,0,0.4), 0 -12px 20px rgba(0,0,0,0.4) inset,  0 2px 3px rgba(0,0,0,0.5) inset':'none',
          display: 'inline-block',
          width: 'calc(${height} * 2)',
          height: '${height}',
          position: 'relative',
        }),
        hover: {
          // backgroundColor: '${schemeBackgroundHover}',
          // boxShadow: '0px 2px 2px rgba(0,0,0,0.4), 0 -8px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset',
          boxShadow:design=='classic'?
            '0px 0px 5px 2px ${schemeShade}, 0 -12px 20px rgba(0,0,0,0.3) inset,  0 2px 3px rgba(0,0,0,0.4) inset':'0px 0px 5px 2px ${schemeShade}',
        },
      },
      trigger: {
        normal: merge({}, getDefaultStyle(), {
          transformOrigin: 'center',
          transitionProperty: 'all',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          boxSizing: 'border-box',
          backgroundColor: '${schemeForeground}',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: '#888',          
          borderRadius: '9999px',
          // boxShadow: '0px 2px 4px rgba(0,0,0,0.4), 0 -12px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset',
          boxShadow:design=='classic'?
            '0px 2px 4px rgba(0,0,0,0.4), 0 12px 20px rgba(0,0,0,0.4) inset, 0 -2px 3px rgba(0,0,0,0.5) inset, 0 2px 3px rgba(0,0,0,0.3) inset':'none',
          display: 'inline-block',
          width: design=='classic'?'calc(${height} - 2px)':'calc(${height} - 4px)',
          height: design=='classic'?'calc(${height} - 2px)':'calc(${height} - 4px)',
          position: 'absolute',
          left: '1px',
          top: design=='classic'?'0px':'1px',
        }),
        hover: {
          backgroundColor: '${schemeForegroundHover}',
        },
        checked: {
          left: design=='classic'?'calc(100% - ${height} + 1px)':'calc(100% - ${height} + 3px)',
          backgroundColor: '${schemeBackground}',
          borderColor: '${schemeBackground}', 
        },
      },
      label: {
        normal: merge({}, getDefaultStyle(), {
          transitionProperty: 'all',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          display: 'none',
          padding: '${schemePaddingTop} calc(${schemeFontSize} / 2)',
          backgroundColor: 'transparent',
          color: '${schemeForeground}',
          textAlign: 'center',
          textShadow: design=='classic'?'0 2px 2px ${schemeShade}':'0 0px 4px ${schemeShade}',
          fontFamily: 'monospace',
          whiteSpace: 'nowrap',
          fontSize: '${schemeFontSize}',
          fontWeight: '${schemeFontWeight}',
          // height: 'calc(${schemePaddingTop} * 2 + ${schemeFontSize})',
          height: '100%',
          overflow: 'hidden',
        }),
        top: {
          display: 'block',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: '100%',
          padding: 'calc(${schemeFontSize} / 2)',
          height: 'auto',
        },
        right: {
          display: 'inline-block',
        },
        bottom: {
          height: 'auto',
          display: 'block',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: '100%',
          padding: 'calc(${schemeFontSize} / 2)',
          top: '100%',
          overflow: 'visible',
        },
        left: {
          display: 'inline-block',
        },
      },
    };
  }

  return getDefaultSwitchStyle[instance.args.designMode][design];
}

export function getDefaultControl() {
  if (!getDefaultControl.source) {
    getDefaultControl.source = document.createElement('div');
    getDefaultControl.source.classList.add('controls');
    getDefaultControl.source.innerHTML =
      '<div class="body"><span class="label"></span>' +
      '<div class="box">' +
      '<div class="trigger"></div>' +
      '</div>' +
      '<span class="label"></span></div>';
  }

  return getDefaultControl.source.cloneNode(true);
}
